/**
 * Pure error-extraction helpers for the admin manual-order page.
 * Kept module-isolated so unit tests can import without dragging
 * in react-router-dom / axios.
 */

export function extractManualOrderError(err) {
  if (!err) return 'Onbekende fout.';
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(d => `${(d.loc || []).slice(-1)[0] || ''}: ${d.msg || 'invalid'}`).join('\n');
  }
  if (detail && typeof detail === 'object') {
    const code = detail.code;
    if (code === 'country_not_allowed') {
      const allowed = (detail.allowedCountries || []).join(', ') || 'BE, NL, FR, LU';
      return `Land ${detail.submittedCountryCode || '?'} wordt niet ondersteund. Toegestaan: ${allowed}.`;
    }
    if (code === 'insufficient_stock') {
      return `Onvoldoende voorraad voor ${detail.name || detail.productId}: gevraagd ${detail.requested}, beschikbaar ${detail.available}.`;
    }
    return JSON.stringify(detail);
  }
  if (err?.message) return err.message;
  return 'Onbekende fout.';
}
